import { ProductUsageReportBaseEvent } from './ProductUsageReportBaseEvent';

export interface ReportEventUnauthenticatedParams {
  event: ProductUsageReportBaseEvent;
}

// helper method for creating ReportEventUnauthenticated parameters
export const createReportEventUnauthenticatedParams =
  (eventType: string, serviceName: string, properties: {}): ReportEventUnauthenticatedParams => ({
    event: { m_eventType: eventType, m_serviceName: serviceName, m_properties: properties }
  });
